import { FetchError, NotAuthorizedError } from "../errors";

export const handleResponseJson = async (res: Response) => {
  if (res.status === 401) {
    throw new NotAuthorizedError();
  }

  if (res.status >= 400) {
    const error = new FetchError(res.statusText, res.status);

    try {
      const json = await res.json();

      if (json.details) {
        error.details = json.details;
      }

      if (json.name) {
        error.name = json.name;
      }

      if (res.status === 400 && json.message) {
        error.message = json.message;
      }
    } catch {
      error.details = [];
    }

    throw error;
  }

  if (res.status === 200) {
    return res.json();
  }

  return undefined;
}